import { Injectable } from '@angular/core';
import { APP_ID } from '../app-id';
import { Provider } from './login.service';

export interface AuthConfig {
  openIdDocument: string;
  clientId: string;
  authRedirectUri: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private configured = false;

  public get isConfigured(): boolean {
    return this.configured;
  }

  auth: AuthConfig | null = null;

  public getLogoutRedirectUri(): string {
    return `${window.location.origin}`;
  }

  public setupConfig(config: Provider): void {
    this.auth = {
      authRedirectUri: this.getLoginRedirectUri(),
      openIdDocument: APP_ID.openIdDocument,
      clientId: config.clientId,
    };
    this.configured = true;
  }

  private getLoginRedirectUri(): string {
    return window.location.origin;
  }
}
